import type { LucideIcon } from 'lucide-react';
import {
  Briefcase,
  CalendarDays,
  ClipboardList,
  FileText,
  HeartPulse,
} from 'lucide-react';
import type { ParticipantTab } from '../../interfaces';

export interface IParticipantNavTab {
  id: ParticipantTab;
  label: string;
  icon: LucideIcon;
}

export const PARTICIPANT_TABS: IParticipantNavTab[] = [
  { id: 'applications', label: 'Applications', icon: Briefcase },
  { id: 'assessments', label: 'Assessments', icon: ClipboardList },
  { id: 'interviews', label: 'Interviews', icon: CalendarDays },
  { id: 'resumes', label: 'Resume', icon: FileText },
  { id: 'wellness', label: 'Wellness', icon: HeartPulse },
];

export const PARTICIPANT_TAB_IDS: ParticipantTab[] = PARTICIPANT_TABS.map((tab) => tab.id);

export const DEFAULT_PARTICIPANT_TAB: ParticipantTab = 'applications';

/** Query-param keys: tab state lives in the URL (deep-linkable, back-button safe). */
export const PARTICIPANT_TAB_PARAM = 'tab';
export const PARTICIPANT_SEARCH_PARAM = 'q';
export const PARTICIPANT_PAGE_PARAM = 'page';

export interface IStatusStyle {
  label: string;
  className: string;
}

/**
 * Keyed on the groups returned by GET /user/profile/dashboard — the backend's
 * _status_to_group() collapses every applicant status into exactly one of these.
 */
export const APPLICATION_STATUS_CONFIG: Record<string, IStatusStyle> = {
  'Applied': {
    label: 'Applied',
    className: 'bg-blue-50 text-blue-600 border border-blue-200',
  },
  'Not Selected': {
    label: 'Not Selected',
    className: 'bg-red-50 text-red-500 border border-red-200',
  },
  'Offered': {
    label: 'Offered',
    className: 'bg-purple-50 text-purple-600 border border-purple-200',
  },
};

export const FALLBACK_APPLICATION_STATUS_CLASS =
  'bg-slate-100 text-slate-500 border border-slate-200';

export const WELLNESS_TYPE_STATUS_CONFIG: Record<string, IStatusStyle> = {
  'Invite Sent': {
    label: 'Not Started',
    className: 'bg-amber-50 text-amber-600 border border-amber-200',
  },
  'In Progress': {
    label: 'In Progress',
    className: 'bg-blue-50 text-blue-600 border border-blue-200',
  },
  'Completed': {
    label: 'Completed',
    className: 'bg-emerald-50 text-emerald-600 border border-emerald-200',
  },
  'Expired': {
    label: 'Expired',
    className: 'bg-red-50 text-red-500 border border-red-200',
  },
  'Superseded': {
    label: 'Superseded',
    className: 'bg-slate-100 text-slate-400 border border-slate-200',
  },
};

export const FALLBACK_WELLNESS_STATUS_CLASS =
  'bg-slate-100 text-slate-500 border border-slate-200';
